import axios from 'axios';

const API_KEY = 'Xohya1fu';

export const getWifi = async(cityDomain) => {
    const instance = axios.create({
        baseURL: 'https://wifi-backend.domru.ru/',
        headers: {
            'Content-Type': 'application/json;charset=utf-8',
        },
    });

    const params = {
        domain: cityDomain,
        systemId: 8,
        timestamp: Math.round(Date.now() / 1000),
    };

    const { default: md5 } = await import('blueimp-md5');
    const tokenMd5 = (params, userKey) => {
        const values = Object.values(params);
        return md5(values.join('') + userKey);
    };

    const hash = tokenMd5(params, API_KEY);

    try {
        const resp = await instance.get('/point/wifi-map', { params:{
            ...params,
            hash,
        } });

        return (
            {
                ...resp,
                ok: true,
            }
        );
    } catch (err) {
        return (
            {
                ...err,
                ok: false,
            }
        );
    }
};
